import React, { useEffect, useState, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector, useDispatch } from 'react-redux';
import { RiCheckboxBlankLine } from 'react-icons/ri';
import TitlePage from '@/components/TitlePage';
import Card from '@/components/Card';
import DataTable from '@/components/DataTable';
import { translate } from '@/i18n/src/locales';
import { addPoleGamification, fetchGamificationPoles } from '@/store/actions/gamification';
import { StyledCard } from './styles';
import Badge from '@/components/Badge';

const Gamification = () => {
    const dispatch = useDispatch();
    const poles = useSelector((state) => state.pole.poles);
    const totalRows = useSelector((state) => state.pole.totalRows);
    const isLoading = useSelector((state) => state.pole.polesIsLoading);

    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [search, setSearch] = useState('');

    useEffect(() => {
        dispatch(fetchGamificationPoles(page, perPage, search));
    }, [dispatch, page, perPage, search]);

    const handlePageChange = useCallback((newPage) => {
        setPage(newPage);
    }, []);

    const handlePerRowsChange = useCallback((newPerPage, newPage) => {
        setPerPage(newPerPage);
        setPage(newPage);
    }, []);

    const handleSearch = useCallback((text) => {
        setSearch(text);
        setPage(1);
    }, []);

    const tooglePoleGamification = useCallback(
        (idPolo) => {
            dispatch(
                addPoleGamification(idPolo)
            );
        },
        [dispatch]
    );

    return (
        <>
            <Helmet>
                <title>Administração Franqueadora - {translate('gamification')}</title>
            </Helmet>
            <TitlePage title={translate('gamification')} />
            <StyledCard>
                <Card>
                    <DataTable
                        data={poles}
                        searchPlaceHolder={`${translate('searchPoleName')} / ${translate('externalCode')}`}
                        columns={[
                            {
                                name: translate('poleName'),
                                selector: 'nomePolo',
                                sortable: true,
                                width: "650px"
                            },
                            {
                                name: translate('externalCode'),
                                selector: 'codigoExternoPolo',
                                sortable: true,
                            },
                            {
                                name: translate('gamification'),
                                sortable: true,
                                selector: (row) => row.gamificacaoAtiva || row.GamificacaoAtiva,
                                cell: (row) => {
                                    const isGamified = row.gamificacaoAtiva || row.GamificacaoAtiva;
                                    const gamificationActive = isGamified === true || isGamified === 1;
                                    return (
                                        <div
                                            className={`check-pole ${gamificationActive ? 'cursor-default' : 'cursor-pointer'}`}
                                            onClick={() => !gamificationActive && tooglePoleGamification(row.idPolo)}
                                            style={{ cursor: gamificationActive ? 'default' : 'pointer' }}
                                        >
                                            {gamificationActive ? (
                                                <Badge type="success" children={translate('active')}></Badge>
                                            ) : (
                                                <RiCheckboxBlankLine size={25} />
                                            )}
                                        </div>
                                    );
                                },
                            },
                        ]}

                        paginationServer={true}
                        totalRows={totalRows}
                        isLoading={isLoading}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onSearch={handleSearch}
                        columnFilter={['nomePolo', 'codigoExternoPolo']}
                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    />
                </Card>
            </StyledCard>
        </>
    );
};

export default Gamification;